export default __webpack_public_path__ + "static/clock-in-out-f52a9ea8e529be4a3047d1395320d89a.png";